import { Component, Input } from '@angular/core';
import { IPaymentConfirmation } from '../../../interfaces/IPayments';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrl: './payment-confirmation.component.scss'
})
export class PaymentConfirmationComponent {
  @Input() paymentConfirmationDetails!: IPaymentConfirmation;
}
